import { css } from "@emotion/react";

import { ClearIcon } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { svgFontSize } from "shared";

const ClearButton = ({ ...props }) => {
    return (
        <Button
            {...props}
            variant={BUTTON_VARIANTS.IconOnly}
            size={BUTTON_SIZES.Tiny}
            color={BUTTON_COLORS.White}
            icon={
                <ClearIcon
                    css={css({
                        ...svgFontSize(16)
                    })}
                />
            }
        />
    );
};

export default ClearButton;
